import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { FiBell } from 'react-icons/fi';
import { useSocket } from '../context/SocketContext';

const SocketNotificationListener = () => {
    const socket = useSocket();

    useEffect(() => {
        if (!socket) return;

        const handleNotification = (data) => {
            console.log('Received notification:', data);
            toast(data.message || 'New notification received', {
                icon: <FiBell size={16} />,
                duration: 5000,
            });
            // You could also dispatch an action to update notification count in redux
        };

        socket.on('notification', handleNotification);

        return () => {
            socket.off('notification', handleNotification);
        };
    }, [socket]);

    return null;
};

export default SocketNotificationListener;
